<template>
  <b-container
    v-if="$store.getters.getSpeakers.length"
    fluid
    style="max-width: 1012px"
    class="mt-5 mb-5"
  >
    <b-row>
      <!-- SPEAKERS LOOP -->
      <b-col
        class="col-xs-12 text-center d-flex"
        cols="6"
        md="4"
        lg="3"
        style="padding: 15px"
        v-for="(speaker, index) in speakers"
        :key="index"
      >
        <div
          class="speaker-card d-flex flex-column align-items-center justify-content-between w-100 h-100"
          tabindex="0"
          role="button"
          @click="openModal(speaker)"
          @keydown.enter="openModal(speaker)"
          @keydown.space.prevent="openModal(speaker)"
        >
          <img
            :src="speaker.profilePicture"
            :style="{
              borderColor: tags_getColor(speaker.sessionTags[0]),
            }"
            class="speaker-img"
            alt=""
            aria-hidden="true"
          />
          <p class="speaker-name text-center mb-0">
            {{ speaker.firstName }} {{ speaker.lastName }}
          </p>
          <p class="speaker-tag text-center mb-0">
            {{ tags_getName(speaker.sessionTags[0]) }}
          </p>
        </div>
      </b-col>
    </b-row>

    <!-- Modal -->
    <SpeakerModal
      :speaker="selectedSpeaker"
      @closed="onModalClose"
      ref="speakerModal"
    />
  </b-container>
</template>
  
<script>
import SpeakerModal from "@/components/modals/SpeakerModal.vue";
import tags from "@/mixins/tags";
export default {
  name: "SpeakerWall",
  components: {
    SpeakerModal,
  },
  mixins: [tags],
  data() {
    return { selectedSpeaker: null };
  },
  computed: {
    speakers() {
      const queryTags = this.$route.query.tags;

      const activeTags =
        typeof queryTags === "string" ? queryTags.split(",") : [];

      if (!activeTags.length) return this.$store.getters.getSpeakers;
      else {
        return this.$store.getters.getSpeakers.filter((speaker) =>
          speaker.sessionTags.some((tag) => activeTags.includes(tag))
        );
      }
    },
  },
  watch: {
    "$store.getters.getSpeakers"(speakers) {
      // When speakers loaded, get speaker from parameter and open modal
      const speakerId = this.$route.params.speakerId;
      if (speakerId && speakers.length) {
        const speaker = this.$store.getters.getSpeakerById(speakerId);
        if (speaker) {
          this.openModal(speaker);
        }
      }
    },
  },
  methods: {
    openModal(speaker) {
      this.selectedSpeaker = speaker;
      // Add speakerId to route if not there
      if (!this.$route.params.speakerId) {
        this.$router.replace({
          name: "Lineup",
          params: { speakerId: speaker._id },
          query: this.$route.query, // preserve tags
        });
      }
      // Wait for modal to render
      this.$nextTick(() => {
        this.$root.$emit("bv::show::modal", "speaker-modal");
      });
    },
    onModalClose() {
      this.selectedSpeaker = null;
      this.$router.replace({
        name: "Lineup",
        query: this.$route.query, // preserve tags
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@use "@/styles/variables.scss" as *;

@media (max-width: 340px) {
  .col-xs-12 {
    flex: 0 0 100%;
    max-width: 100%;
  }
}
.speaker-img {
  border-radius: 200px;
  width: 100%;
  border: 5px solid;
  margin-bottom: 16px;
  @media (min-width: 576px) {
    border: 7px solid;
  }
}
.speaker-name {
  font-weight: 600;
}
.speaker-tag {
  font-weight: 300;
}

.speaker-card {
  background: $white;
  border-radius: 5px;
  padding: 24px;
  cursor: pointer;
  transition: 0.3s ease;
  box-shadow: 0px 8px 16px 0px #00000033;

  line-height: 28px;
  letter-spacing: 0;
  font-size: 14px;
  @media (min-width: 576px) {
    font-size: 16px;
  }
}
.speaker-card:hover,
.speaker-card:focus-visible {
  transform: scale(1.05); // makes it 5% bigger
}
</style>
  


// WEBPACK FOOTER //
// src/components/SpeakerWall.vue